(() => {
  if (customElements.get('yg-flash-sale-countdown')) return;

  class YgFlashSaleCountdown extends HTMLElement {
    connectedCallback() {
      this.endTime = this.parseEndTime(this.dataset.endTime);
      this.update();

      if (this.endTime && this.endTime > Date.now()) {
        this.interval = window.setInterval(() => this.update(), 1000);
      }
    }

    disconnectedCallback() {
      if (this.interval) window.clearInterval(this.interval);
    }

    parseEndTime(value) {
      if (!value) return null;
      const timestamp = Date.parse(value.trim().replace(' ', 'T'));
      return Number.isNaN(timestamp) ? null : timestamp;
    }

    update() {
      const remaining = this.endTime ? Math.max(0, this.endTime - Date.now()) : 0;
      const totalSeconds = Math.floor(remaining / 1000);
      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        mins: Math.floor((totalSeconds % 3600) / 60),
        secs: totalSeconds % 60,
      };

      Object.entries(values).forEach(([unit, value]) => {
        const node = this.querySelector(`[data-countdown-value="${unit}"]`);
        if (node) node.textContent = String(value).padStart(2, '0');
      });

      if (remaining === 0 && this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }
  }

  customElements.define('yg-flash-sale-countdown', YgFlashSaleCountdown);
})();
